export enum FromScreen {
PAYSHAPAMOUNT= "pay-payshap-amount",
PAYSHAPSCANQR= "payshap-qr"
}
